export const INIT_USER_FORM_DATA = {
  email_id: "",
  role: "user",
} as const;
